import React from 'react'
import { AriaListBoxOptions, useListBox } from 'react-aria'
import { SelectState } from 'react-stately'
import { YearMonthItem } from '../year-month-item/YearMonthItem'

type Props = AriaListBoxOptions<{ value: string }> & { state: SelectState<{ value: string }> }
export const YearMonthSelectList = ({ state, ...props }: Props) => {
  const listBoxRef = React.useRef<HTMLUListElement>(null)
  const { listBoxProps } = useListBox(props, state, listBoxRef)

  return (
    <ul {...listBoxProps} ref={listBoxRef}>
      {[...state.collection].map(item => {
        return <YearMonthItem key={item.key} item={item} state={state} />
      })}
    </ul>
  )
}
